module.exports = __webpack_public_path__ + "img/belgium-congenital-and-perinatal-diseases-female.72c7722b.png";